<script setup>
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const transactions = [
  {
    no: 1,
    kutipan: 'Jumlah Kutipan',
    jumlah: 'RM753.6M',
  },
  {
    no: 2,
    kutipan: 'Jumlah Kutipan Tahun 2022',
    jumlah: 'RM176.6M',
  },
  {
    no: 3,
    kutipan: 'Jumlah Kutipan Tahun 2023',
    jumlah: 'RM334.0M',
  },
  {
    no: 4,
    kutipan: 'Jumlah Kutipan Tahun 2024',
    jumlah: 'RM178.0M',
  },
]
</script>

<template>
  <div class="table-container">
    <h2>Status Transaksi PBTPay</h2>
    <VTable class="text-no-wrap">
      <thead>
        <tr>
          <th>No</th>
          <th>Kutipan</th>
          <th>Jumlah (RM)</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="item in transactions"
          :key="item.no"
        >
          <td>{{ item.no }}</td>
          <td>{{ item.kutipan }}</td>
          <td>{{ item.jumlah }}</td>
        </tr>
      </tbody>
    </VTable>
  </div>
</template>

<style scoped>
.table-container {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: auto;
}

h2 {
  font-size: 24px;
  font-weight: bold;
  color: #150069;
  margin-bottom: 20px;
  text-align: center;
}

VTable {
  width: 100%;
  border-collapse: collapse;
}

VTable th,
VTable td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

VTable th {
  background-color: #f5f5f5;
  color: #150069;
  font-weight: bold;
}

VTable td {
  color: #333;
}
</style>
